import { render, staticRenderFns } from "./detail-for-completed.vue?vue&type=template&id=3457486a&"
import script from "./detail-for-completed.vue?vue&type=script&lang=js&"
export * from "./detail-for-completed.vue?vue&type=script&lang=js&"
import style0 from "./detail-for-completed.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports